import gql from 'graphql-tag';

const COUPLE_ZONE_BY_CODE_TO_SONOS = gql`
  mutation coupleZoneByCodeToSonos($zoneCode: String!, $linkCode: String!) {
    coupleZoneByCodeToSonos(zoneCode: $zoneCode, linkCode: $linkCode)
  }
`;

export { COUPLE_ZONE_BY_CODE_TO_SONOS };
